import memoize from 'memoize-one'

import React from 'react'
import api from '@disco/api/server'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
let _abortController: AbortController | null | undefined = null

const memoizeCb = async (input: string) => {
  if (_abortController) {
    _abortController.abort()
  }

  const query = {
    sort: `["-score"]`,
    type: 'track',
    is_video: true,
    search_folders: true,
    include_playlist_tracks: true,
    q: input,
  }
  _abortController = new AbortController()
  const response = await api.getSearchResultsByQuery(
    undefined,
    query,
    undefined,
    _abortController.signal,
  )
  return response.results
}

// memoize function to not trigger api call when input doesn't change
let fetchVideos = memoize(memoizeCb)
type Props = {
  onChange: (...args: Array<any>) => any
  disabled?: boolean
  value?: { label: string; value: string | number } | null
}

const DiscoVideoSelection = ({
  onChange,
  disabled,
  value,
}: Props): React.ReactNode => {
  return (
    <CustomDropdown
      async
      clearable
      loadOptions={async (input, callback) => {
        if (disabled) return null
        const videos = await fetchVideos(input)
        const options = {
          options: videos.map(video => ({
            label: video.name,
            value: video.id,
          })),
          complete: false,
        }
        return callback(null, options)
      }}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

export default DiscoVideoSelection
